var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero text-center pt-5"},[_c('div',{staticClass:"hero-image"},[_c('img',{attrs:{"src":require('@/assets/images/hero.png'),"width":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }